module.exports = __webpack_public_path__ + "img/ScreenCap_Up_36dp.e69c3cd0.svg";